// src/features/release-notes/i18n/en.ts

export default {
  name: "What's new",
  title: "What's new",
  subtitle: 'Recent changes to the application that may affect you, newest first.',
  empty: 'There is nothing new to show yet.',
  new: 'New',
  gotIt: 'Got it',
  close: 'Close',
  openScreen: 'Go to the screen',
  openManual: 'See in the manual',
  kind: {
    action: 'Needs your attention',
    guests: 'For your guests',
    feature: 'New feature',
  },
  dialog: {
    title: "What's new",
    intro: 'These recent changes may affect your daily work.',
  },
};
